
// Choose Journey (React App)
import './js/choose-journey';

//
import './js/pdf-export';

// Nice select dropdowns
require('jquery-nice-select');

// Copy to clipboard
import ClipboardJS from 'clipboard';

( function ( $ ) {
	'use strict';

	// Focus Search if Searchform is empty
	$( '.search-form' ).on( 'submit', function ( e ) {
		var search = $( '#s' );
		if ( search.val().length < 1 ) {
			e.preventDefault();
			search.focus();
		}
	} );


	// Navbar (mobile toggle)
	$('.navbar-toggler').click((e) => {
		e.preventDefault();
		$('#navbar').toggleClass('expanded');
	});


	// Library filters (Mobile)
	$('.filters-toggler').click((e) => {
		e.preventDefault();
		$('.library-filters .filters').toggleClass('expanded');
	});


	// Nice selects
	$(document).ready(function() {
		$('select').niceSelect();
	});


	// Library form, auto submit
	$(document).ready(function() {
		$('#brooke-library select').change(function() {
			$('#brooke-library').addClass('processing');
			$('#brooke-library').submit();
		});
	});


	// Copy URL
	var clipboard = new ClipboardJS('.copy');
	clipboard.on('success', function(e) {
		$(e.trigger).find('span').text($(e.trigger).data('copied-text'));
	});
	clipboard.on('error', function(e) {
		$(e.trigger).find('span').text('Error');
	});


	// Jump list
	$('.jump-list').on('change', function(e) {
		e.preventDefault();
		window.location.href = this.value;
	});

}( jQuery ) );
